//防抖
export const debounce = (fn, wait) => {
  var timeout = null
  return function() {
    if (timeout !== null) clearTimeout(timeout)
    timeout = setTimeout(fn, wait)
  }
}
export const getQueryString = (url, name, defaultval = null) => {
  if (!url) {
    return null
  }
  url = url.replace(/\S*#\//, '')
  let reg = new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i')
  let r = url.match(reg)
  if (r != null) return decodeURIComponent(r[1])
  return defaultval
}
// 时间格式化
export const formatTime = (date, type) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  if (type && type === 1) {
    return (
      [month, day].map(formatNumber).join('月') +
      '日 ' +
      [hour, minute, second].map(formatNumber).join(':')
    )
  } else {
    return (
      [year, month, day].map(formatNumber).join('/') +
      ' ' +
      [hour, minute, second].map(formatNumber).join(':')
    )
  }
}
// 加零函数
const formatNumber = (n) => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 判断是否微信浏览器环境
export const getIsWxClient = () => {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true //是微信环境
  } else {
    return false //不是微信环境
  }
}

//向本地存储数据
export const setLocalStorage = (key, value, days) => {
  // 设置过期原则
  if (!value) {
    sessionStorage.removeItem(key)
  } else {
    var Days = days || 30 // 默认保留1天
    var exp = new Date()
    sessionStorage[key] = JSON.stringify({
      value,
      expires: exp.getTime() + Days * 24 * 60 * 60 * 1000,
    })
  }
}

// eg:
// setLocalStorage('JSXM',data.data);

//获取本地存储数据
export const getLocalStorage = (key) => {
  try {
    let o = JSON.parse(sessionStorage[key])
    if (!o || o.expires < Date.now()) {
      return false
    } else {
      return o.value
    }
  } catch (e) {
    // 兼容其他localstorage
    console.log(e)
    return sessionStorage[key]
  } finally {
  }
}

// eg:
// getLocalStorage('JSXM')

export const regYuanToFen = (yuan, digit) => {
  let m = 0,
    s1 = yuan.toString(),
    s2 = digit.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}
export const regFenToYuan = (fen) => {
  let num = fen
  num = fen * 0.01
  num += ''
  let reg =
    num.indexOf('.') > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g
  num = num.replace(reg, '$1')
  num = toDecimal2(num)
  return num
}
export const toDecimal2 = (x) => {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  var f = Math.round(x * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

function formatPrice(value) {
  let val = ''
  if (value == '' || value === undefined || value == null) {
    val = '0.00'
  } else {
    val = Number(value).toFixed(2)
  }
  return val
}
//向本地存储数据
const setStorage = (key, value, days) => {
  // 设置过期原则
  if (!value) {
    sessionStorage.removeItem(key)
  } else {
    var Days = days || 30 // 默认保留1天
    var exp = new Date()
    sessionStorage[key] = JSON.stringify({
      value,
      expires: exp.getTime() + Days * 24 * 60 * 60 * 1000,
    })
  }
}
function checkIos() {
  let u = navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}
export const smartInit = (callback) => {
  SmartCity.getUserInfo(function(res) {
    if (res && res.userInfo) {
      setStorage('userInfo', res.userInfo)
      SmartCity.getSystemInfo(function(resSys) {
        let appStatusBarHeight = 0
        if (!checkIos()) {
          setStorage('isios', 0)
          appStatusBarHeight = parseInt(resSys.deviceInfo.appStatusBarHeight)
        } else {
          setStorage('isios', 1)
          appStatusBarHeight = parseInt(resSys.appStatusBarHeight)
        }
        setStorage('deviceInfo', resSys.deviceInfo)
        setStorage('appStatusBarHeight', appStatusBarHeight)
        callback()
      })
    } else {
      SmartCity.goLogin()
    }
  })
}
//倒计时
export const leftTimer = (year, day, hour, month, nowHour) => {
  var leftTime = new Date(year, +month - 1, day, hour, 0, 0) - nowHour //计算剩余的毫秒数
  // debugger
  // var leftTime =
  //   new Date(year, +new Date().Format('MM') - 1, day, hour, 0, 0) - new Date() //计算剩余的毫秒数
  var days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10) //计算剩余的天数
  var hours = parseInt((leftTime / 1000 / 60 / 60) % 24, 10) //计算剩余的小时
  var minutes = parseInt((leftTime / 1000 / 60) % 60, 10) //计算剩余的分钟
  var seconds = parseInt((leftTime / 1000) % 60, 10) //计算剩余的秒数
  days = checkTime(days)
  hours = checkTime(hours)
  minutes = checkTime(minutes)
  seconds = checkTime(seconds)
  let leftTimeObj = {
    days,
    hours,
    minutes,
    seconds,
  }
  return leftTimeObj
}
//补零
function checkTime(i) {
  //将0-9的数字前面加上0，例1变为01
  if (i < 10) {
    i = '0' + i
  }
  return i
}
